import { render } from "./ProjectsOverview.vue?vue&type=template&id=2a2a4c66"
import script from "./ProjectsOverview.vue?vue&type=script&lang=js"
export * from "./ProjectsOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__